import { createActions } from "redux-actions";
import { createRequestAction } from "../utils";

const oauthAppsActions = {
  ...createActions({
    GET_OAUTH_APPS: () => ({}),
    CREATE_OAUTH_APP: ({ name, redirectURI, grantTypes, scope, userID, trusted }) => ({
      name,
      redirectURI,
      grantTypes,
      scope,
      userID,
      trusted,
    }),
    DELETE_OAUTH_APP: (clientID) => ({ clientID }),
  }),
  ...createRequestAction("GET_OAUTH_APPS"),
  ...createRequestAction("CREATE_OAUTH_APP"),
  ...createRequestAction("DELETE_OAUTH_APP"),
};

export default oauthAppsActions;
